import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import MisHeader from '../../Components/MisHeader'
import Counter from '../../Components/Counter'

class AnswerBattle extends React.Component {
  constructor(props) {
    super(props)
  }

  answerBattleQuestion(answer) {
    const { currentQuestion, answerBattleQuestion } = this.props

    answerBattleQuestion({ ...currentQuestion, selectedKey: answer.key })
  }

  renderAnswers(answer) {
    const { loading, addHowlSound } = this.props
    answer.text = answer.text || answer.title
    return (
      <div
        onClick={() => {
          !loading && this.answerBattleQuestion(answer)
          addHowlSound('button_click')
        }}
        className="mis--battle__questions--item"
        key={answer.key}
      >
        <label htmlFor={answer.id}>
          <FormattedMessage id={answer.text} />
        </label>
        <input
          id={answer.key}
          key={answer.key}
          name="answer"
          value={answer.key}
          type="radio"
        ></input>
      </div>
    )
  }

  render() {
    const {
      currentQuestion,
      error,
      battle,
      individualBattle,
      userInfo,
      giveUp,
      addHowlSound,
      hideTabs,
    } = this.props
    const { helpBtn, settingsBtn } = hideTabs || {}
    let info = this.props.info || {}
    let usingBattle = individualBattle ? individualBattle : battle
    let ownResults = usingBattle.results ? usingBattle.results[userInfo.licenseId] : false
    const startTime = ownResults ? ownResults.startTime : new Date().getTime()
    this.startTime = this.startTime ? this.startTime : startTime

    if (error) {
      return (
        <div>
          <FormattedMessage id="questions.no_question" />
        </div>
      )
    }
    if (!currentQuestion) {
      return (
        <div>
          <FormattedMessage id="questions.loading" />
        </div>
      )
    }
    const answers = currentQuestion.choices

    return (
      <div className="container background background--mina">
        <div className="content">
          <div className="mis">
            <MisHeader helpBtn={helpBtn} settingsBtn={settingsBtn} />
            <div className="mis--body">
              <div className="mis--battle">
                <div className="mis--battle__head">
                  <div className="mis--battle__title visibility--hidden">
                    <span>
                      <FormattedMessage id="battles.challenge" />
                    </span>
                  </div>
                  <Counter
                    dateTime={this.startTime}
                    countdown={false}
                    className="mis--battle__timer"
                  />
                  <div className="mis--battle__counter">
                    <div className="mis--battle__counter--item">
                      <span className="green">{info.hits}</span>
                    </div>
                    <div className="mis--battle__counter--item">
                      <span className="red">{info.fails}</span>
                    </div>
                  </div>
                </div>
                <div className="mis--num__question">{info.question || 1}/5</div>
                <div className="mis--battle__block">
                  <div className="mis--battle__questions">
                    <div className="mis--battle__questions--title">
                      <FormattedMessage id={currentQuestion.question} />
                    </div>
                    {answers.map((a) => this.renderAnswers(a))}
                    <div className="mis--battle__buttons">
                      <div
                        onClick={() => {
                          giveUp()
                          addHowlSound('wrong_answer')
                        }}
                        className="mis--button display--none"
                      >
                        <span>
                          <FormattedMessage id="battles.cancel" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

AnswerBattle.propTypes = {
  battle: PropTypes.object,
  answerBattleQuestion: PropTypes.func,
  giveUp: PropTypes.func,
  currentQuestion: PropTypes.object,
  individualBattle: PropTypes.object,
  userInfo: PropTypes.object,
  info: PropTypes.object,
  error: PropTypes.object,
  loading: PropTypes.bool,
  addHowlSound: PropTypes.func,
  hideTabs: PropTypes.object,
}

export default AnswerBattle
